/**
 * Offer buy box: resolves the variant from the option chips, switches offers, recalculates every price
 * and token text, updates the gifts tracker and gallery, shows the delivery estimate, and adds the
 * selected offer (plus its unlocked gift lines) to the cart or sends it straight to checkout.
 * One script serves every instance on the page and re-initialises sections reloaded by the theme editor.
 */
(function () {
  function root() {
    return (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
  }

  function parseJSON(el) {
    if (!el) return null;
    try { return JSON.parse(el.textContent); } catch (e) { return null; }
  }

  function formatMoney(cents) {
    if (cents == null || isNaN(cents)) return '';
    try {
      if (typeof price === 'function') return price(cents, true);
    } catch (e) { /* theme price helper failed; use the fallback below */ }
    var val = Math.round(cents) / 100;
    var str = val % 1 === 0 ? val.toFixed(0) : val.toFixed(2);
    return '$' + str.replace(/\B(?=(\d{3})+(?!\d))/g, ',');
  }

  function fetchCart() {
    if (typeof getCart === 'function') return getCart();
    return fetch(root() + 'cart.js').then(function (r) { return r.json(); });
  }

  function postItems(payload) {
    if (typeof addProduct === 'function') return addProduct(payload);
    return fetch(root() + 'cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(payload)
    }).then(function (r) { return r.json(); });
  }

  function clearCart() {
    return fetch(root() + 'cart/clear.js', { method: 'POST' }).then(function (r) { return r.json(); });
  }

  /* Adds business days (weekends skipped) to today. */
  function addBusinessDays(days) {
    var d = new Date();
    var added = 0;
    while (added < days) {
      d.setDate(d.getDate() + 1);
      var day = d.getDay();
      if (day !== 0 && day !== 6) added++;
    }
    return d;
  }

  function formatDate(d) {
    return d.toLocaleDateString('en-US', { weekday: 'short', month: 'short', day: 'numeric' });
  }

  function init(section) {
    if (section.dataset.offerBoxReady) return;
    var product = parseJSON(section.querySelector('[data-offer-box-product]'));
    var cfg = parseJSON(section.querySelector('[data-offer-box-config]'));
    if (!product || !product.variants || !cfg) return;
    section.dataset.offerBoxReady = 'true';

    var offers = cfg.offers || [];
    var gifts = cfg.gifts || [];
    var purchasable = (cfg.purchasableIds || []).filter(Boolean).map(String);

    var stickyRoot = section.querySelector('[data-sticky]');
    var sticky = stickyRoot ? {
      root: stickyRoot,
      btn: stickyRoot.querySelector('[data-sticky-atc]'),
      label: stickyRoot.querySelector('[data-sticky-label]'),
      price: stickyRoot.querySelector('[data-sticky-price]'),
      compare: stickyRoot.querySelector('[data-sticky-compare]'),
      title: stickyRoot.querySelector('[data-sticky-title]'),
      variant: stickyRoot.querySelector('[data-sticky-variant]')
    } : null;

    var els = {
      offers: section.querySelectorAll('[data-offer]'),
      price: section.querySelector('[data-price]'),
      compare: section.querySelector('[data-compare]'),
      priceBadge: section.querySelector('[data-price-badge]'),
      atc: section.querySelector('[data-atc]'),
      atcLabel: section.querySelector('[data-atc-label]'),
      atcPrice: section.querySelector('[data-atc-price]'),
      atcCompare: section.querySelector('[data-atc-compare]'),
      error: section.querySelector('[data-error]'),
      notes: section.querySelectorAll('[data-offer-note]'),
      tracker: section.querySelectorAll('[data-tracker-item]'),
      galleries: section.querySelectorAll('[data-gallery]')
    };

    function findVariantById(id) {
      for (var i = 0; i < product.variants.length; i++) {
        if (String(product.variants[i].id) === String(id)) return product.variants[i];
      }
      return null;
    }

    /* Pages cannot pre-select a variant in Liquid, so honour ?variant= here. */
    var urlVariant = null;
    try { urlVariant = findVariantById(new URLSearchParams(window.location.search).get('variant')); } catch (e) { /* no URLSearchParams */ }

    var state = {
      variant: urlVariant || findVariantById(cfg.activeVariantId) || product.variants[0],
      offer: cfg.selected || 0
    };

    function isPurchasable(variant) {
      return !!variant && purchasable.indexOf(String(variant.id)) !== -1;
    }

    function selectedOptions() {
      return Array.prototype.map.call(section.querySelectorAll('[data-option-group]'), function (group) {
        var checked = group.querySelector('[data-option-input]:checked');
        return checked ? checked.value : null;
      });
    }

    function findVariant(values) {
      for (var i = 0; i < product.variants.length; i++) {
        var v = product.variants[i];
        var match = values.every(function (value, idx) { return value == null || v.options[idx] === value; });
        if (match) return v;
      }
      return null;
    }

    /* Same calculation as the Liquid: see the comment above the offer loop in the section. */
    function offerPrices(variant, index) {
      var offer = offers[index] || {};
      var qty = parseInt(offer.quantity, 10) || 1;
      var unit = variant ? variant.price : 0;
      var compareUnit = Math.max((variant && variant.compare_at_price) || 0, unit);
      var total = unit * qty;
      /* Bundle price setting: a fixed total that should match the live automatic discount. */
      if (offer.hasBundlePrice && offer.bundlePrice > 0) {
        total = offer.bundlePrice;
        unit = Math.round(total / qty);
      }
      var compare = compareUnit * qty;
      var unlocked = gifts.map(function (gift) {
        return index + 1 >= (parseInt(gift.unlockAt, 10) || 1);
      });
      if (offer.compareIncludesGifts) {
        unlocked.forEach(function (on, i) { if (on) compare += gifts[i].value || 0; });
      }
      var savings = compare > total ? compare - total : 0;
      return {
        qty: qty,
        unit: unit,
        total: total,
        compare: compare > total ? compare : 0,
        savings: savings,
        percent: savings && compare ? Math.round(savings * 100 / compare) : 0,
        unlocked: unlocked
      };
    }

    function fillTokens(tpl, p) {
      return String(tpl || '')
        .replace(/\[unit_price\]/g, formatMoney(p.unit))
        .replace(/\[total_price\]/g, formatMoney(p.total))
        .replace(/\[quantity\]/g, String(p.qty))
        .replace(/\[savings\]/g, formatMoney(p.savings))
        .replace(/\[percent\]/g, p.percent + '%');
    }

    function setText(el, value) {
      if (el) el.textContent = value == null ? '' : String(value);
    }

    function render() {
      var variant = state.variant;
      var all = offers.map(function (_, i) { return offerPrices(variant, i); });

      Array.prototype.forEach.call(els.offers, function (card) {
        var i = parseInt(card.dataset.index, 10);
        var p = all[i];
        if (!p) return;
        var input = card.querySelector('[data-offer-input]');
        var selected = i === state.offer;
        card.classList.toggle('is-selected', selected);
        if (input) input.checked = selected;
        setText(card.querySelector('[data-offer-price]'), formatMoney(p.total));
        setText(card.querySelector('[data-offer-compare]'), p.compare ? formatMoney(p.compare) : '');
        var sub = card.querySelector('[data-offer-sub]');
        if (sub) setText(sub, fillTokens(sub.dataset.tpl, p));
      });

      var sel = all[state.offer];
      if (!sel) return;
      setText(els.price, formatMoney(sel.total));
      setText(els.compare, sel.compare ? formatMoney(sel.compare) : '');
      if (els.priceBadge) {
        setText(els.priceBadge, fillTokens(els.priceBadge.dataset.tpl, sel));
        els.priceBadge.hidden = sel.savings <= 0;
      }

      Array.prototype.forEach.call(els.notes, function (note) {
        note.hidden = parseInt(note.dataset.offerNote, 10) !== state.offer;
      });

      Array.prototype.forEach.call(els.tracker, function (item) {
        var on = !!sel.unlocked[parseInt(item.dataset.trackerItem, 10)];
        item.classList.toggle('is-unlocked', on);
        var stateOn = item.querySelector('[data-tracker-state-on]');
        if (stateOn) stateOn.hidden = !on;
      });

      section.querySelectorAll('[data-option-group]').forEach(function (group) {
        var pos = parseInt(group.dataset.optionPosition, 10) - 1;
        group.querySelectorAll('[data-option-input]').forEach(function (input) {
          var match = !!variant && variant.options[pos] === input.value;
          input.checked = match;
          input.closest('label').classList.toggle('is-selected', match);
        });
        if (variant) setText(group.querySelector('[data-option-value]'), variant.options[pos]);
      });

      if (els.atc) els.atc.disabled = !isPurchasable(variant);
      setText(els.atcLabel, !variant ? cfg.unavailableText : (isPurchasable(variant) ? cfg.atcText : cfg.soldOutText));
      setText(els.atcPrice, formatMoney(sel.total));
      setText(els.atcCompare, sel.compare ? formatMoney(sel.compare) : '');
      if (sticky) {
        sticky.btn.disabled = els.atc ? els.atc.disabled : false;
        setText(sticky.label, els.atcLabel ? els.atcLabel.textContent : '');
        setText(sticky.price, formatMoney(sel.total));
        setText(sticky.compare, sel.compare ? formatMoney(sel.compare) : '');
        var card = section.querySelector('[data-offer][data-index="' + state.offer + '"] .c-offer-box__offer-title');
        if (card) setText(sticky.title, card.textContent);
        if (variant) setText(sticky.variant, variant.title);
      }

      showGallery(variant);
    }

    /* ── Offer countdown: ticks to the fixed end time, then hides for good ── */
    var countdown = section.querySelector('[data-countdown]');
    if (countdown) {
      var endAt = Date.parse(countdown.dataset.end);
      var cdEls = {
        daysUnit: countdown.querySelector('[data-countdown-days-unit]'),
        daysSep: countdown.querySelector('[data-countdown-days-sep]'),
        days: countdown.querySelector('[data-countdown-days]'),
        hours: countdown.querySelector('[data-countdown-hours]'),
        minutes: countdown.querySelector('[data-countdown-minutes]'),
        seconds: countdown.querySelector('[data-countdown-seconds]')
      };
      var pad = function (n) { return n < 10 ? '0' + n : String(n); };
      var timer = null;
      var tick = function () {
        var left = Math.floor((endAt - Date.now()) / 1000);
        if (isNaN(left) || left <= 0 || !document.contains(countdown)) {
          countdown.hidden = true;
          if (timer) clearInterval(timer);
          return;
        }
        var d = Math.floor(left / 86400);
        var h = Math.floor((left % 86400) / 3600);
        var m = Math.floor((left % 3600) / 60);
        cdEls.daysUnit.hidden = cdEls.daysSep.hidden = d === 0;
        setText(cdEls.days, pad(d));
        setText(cdEls.hours, pad(h));
        setText(cdEls.minutes, pad(m));
        setText(cdEls.seconds, pad(left % 60));
        countdown.hidden = false;
      };
      tick();
      if (!countdown.hidden) timer = setInterval(tick, 1000);
    }

    /* ── Gallery ─────────────────────────────────────────────────────── */
    function showGallery(variant) {
      if (!variant || !els.galleries.length) return;
      var target = section.querySelector('[data-gallery][data-variant-id="' + variant.id + '"]');
      if (!target) return;
      Array.prototype.forEach.call(els.galleries, function (g) {
        var active = g === target;
        g.hidden = !active;
        g.classList.toggle('is-active', active);
      });
    }

    function bindGallery(gallery) {
      var track = gallery.querySelector('[data-gallery-track]');
      if (!track) return;
      var slides = track.querySelectorAll('[data-slide]');
      var thumbs = gallery.querySelectorAll('[data-thumb]');
      var prev = gallery.querySelector('[data-gallery-prev]');
      var next = gallery.querySelector('[data-gallery-next]');

      function current() {
        return Math.round(track.scrollLeft / Math.max(track.clientWidth, 1));
      }
      function goTo(i) {
        var n = slides.length;
        if (!n) return;
        i = (i + n) % n;
        track.scrollTo({ left: i * track.clientWidth });
      }
      function sync() {
        var i = current();
        thumbs.forEach(function (t, idx) {
          var on = idx === i;
          t.classList.toggle('is-active', on);
          t.setAttribute('aria-current', on ? 'true' : 'false');
        });
      }

      var ticking = false;
      track.addEventListener('scroll', function () {
        if (ticking) return;
        ticking = true;
        requestAnimationFrame(function () { ticking = false; sync(); });
      }, { passive: true });
      thumbs.forEach(function (t) {
        t.addEventListener('click', function () { goTo(parseInt(t.dataset.index, 10) || 0); });
      });
      if (prev) prev.addEventListener('click', function () { goTo(current() - 1); });
      if (next) next.addEventListener('click', function () { goTo(current() + 1); });
    }

    Array.prototype.forEach.call(els.galleries, bindGallery);

    /* ── Delivery estimate ───────────────────────────────────────────── */
    var delivery = section.querySelector('[data-delivery]');
    if (delivery) {
      var min = parseInt(cfg.deliveryMin, 10) || 1;
      var max = Math.max(parseInt(cfg.deliveryMax, 10) || min, min);
      var dateText = min === max
        ? formatDate(addBusinessDays(min))
        : formatDate(addBusinessDays(min)) + ' – ' + formatDate(addBusinessDays(max));
      var target = delivery.querySelector('[data-delivery-text]');
      var parts = String(delivery.dataset.tpl || '').split('[date]');
      target.textContent = '';
      parts.forEach(function (part, i) {
        if (i > 0) {
          var strong = document.createElement('strong');
          strong.textContent = dateText;
          target.appendChild(strong);
        }
        if (part) target.appendChild(document.createTextNode(part));
      });
      delivery.hidden = false;
    }

    /* ── Add to cart ─────────────────────────────────────────────────── */
    function setLoading(on) {
      [els.atc, sticky && sticky.btn].forEach(function (btn) {
        if (!btn) return;
        btn.classList.toggle('is-loading', on);
        btn.setAttribute('aria-busy', on ? 'true' : 'false');
      });
    }

    function showError(msg) {
      setText(els.error, msg || '');
    }

    /**
     * Adds the offer's quantity as a one-time purchase plus one line per unlocked product gift. Gift lines are
     * tagged `_bundle_gift` / `_gift_for` (not `_gift`, which the layout removes from carts without a
     * subscription); the layout drops them when their variant leaves the cart. Gifts the variant already has in
     * the cart are not added twice. A gift is free only if a Shopify automatic discount covers it.
     */
    function addToCart() {
      var variant = state.variant;
      var p = offerPrices(variant, state.offer);
      if (!variant || !isPurchasable(variant)) return Promise.resolve();

      setLoading(true);
      showError('');

      var giftIds = gifts
        .filter(function (gift, i) { return p.unlocked[i] && parseInt(gift.id, 10); })
        .map(function (gift) { return String(gift.id); });

      var existing = giftIds.length && !cfg.directCheckout
        ? fetchCart().then(function (cart) {
            return (cart.items || []).filter(function (item) {
              return item.properties && item.properties._bundle_gift && String(item.properties._gift_for) === String(variant.id);
            }).map(function (item) { return String(item.variant_id); });
          }).catch(function () { return []; })
        : Promise.resolve([]);

      return existing.then(function (have) {
        var items = [];
        giftIds.forEach(function (id) {
          if (have.indexOf(id) !== -1) return;
          items.push({ id: parseInt(id, 10), quantity: 1, properties: { _bundle_gift: true, _gift_for: String(variant.id) } });
        });
        items.push({ id: variant.id, quantity: p.qty });
        if (cfg.directCheckout) return clearCart().then(function () { return postItems({ items: items }); });
        return postItems({ items: items });
      }).then(function (res) {
        if (res && res.status && res.status >= 400) {
          throw new Error(res.description || res.message || 'Could not add to cart.');
        }
        if (cfg.directCheckout) {
          window.location.href = root() + 'checkout';
          return;
        }
        setLoading(false);
        if (typeof openCart === 'function') return openCart();
        window.location.href = root() + 'cart';
      }).catch(function (err) {
        setLoading(false);
        showError(err && err.message ? err.message : 'Something went wrong. Please try again.');
      });
    }

    /* ── Events ──────────────────────────────────────────────────────── */
    section.querySelectorAll('[data-option-input]').forEach(function (input) {
      input.addEventListener('change', function () {
        state.variant = findVariant(selectedOptions());
        render();
      });
    });

    function selectOffer(i) {
      var p = offerPrices(state.variant, i);
      if (i === state.offer) return;
      state.offer = i;
      render();
    }

    Array.prototype.forEach.call(els.offers, function (card) {
      var i = parseInt(card.dataset.index, 10);
      var input = card.querySelector('[data-offer-input]');
      if (input) input.addEventListener('change', function () { if (input.checked) selectOffer(i); });
      /* The gift list sits outside the label, so clicks there select the card too. */
      card.addEventListener('click', function (event) {
        if (event.target.closest('label, input')) return;
        selectOffer(i);
      });
    });

    if (els.atc) els.atc.addEventListener('click', addToCart);

    /* Sticky bar: shown while the main button is out of view above the viewport. */
    if (sticky && els.atc && 'IntersectionObserver' in window) {
      sticky.btn.addEventListener('click', addToCart);
      var setSticky = function (on) {
        sticky.root.classList.toggle('is-visible', on);
        sticky.root.setAttribute('aria-hidden', on ? 'false' : 'true');
        sticky.root.inert = !on;
        sticky.btn.tabIndex = on ? 0 : -1;
      };
      new IntersectionObserver(function (entries) {
        var entry = entries[0];
        setSticky(!entry.isIntersecting && entry.boundingClientRect.top < 0);
      }).observe(els.atc);
    }

    /* ── Accordions: animate the body height when a <details> opens or closes ── */
    var reduceMotion = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    section.querySelectorAll('.c-offer-box__accordion').forEach(function (details) {
      var summary = details.querySelector('summary');
      var body = details.querySelector('.c-offer-box__accordion-body');
      if (!summary || !body || !body.animate) return;
      var anim = null;

      function run(from, to, done) {
        if (anim) anim.cancel();
        body.style.overflow = 'hidden';
        anim = body.animate(
          [{ height: from + 'px', opacity: to ? 0 : 1 }, { height: to + 'px', opacity: to ? 1 : 0 }],
          { duration: 300, easing: 'ease' }
        );
        anim.onfinish = function () {
          anim = null;
          body.style.overflow = '';
          if (done) done();
        };
        anim.oncancel = function () { body.style.overflow = ''; };
      }

      summary.addEventListener('click', function (event) {
        if (reduceMotion) return;
        event.preventDefault();
        if (details.open && !details.classList.contains('is-closing')) {
          details.classList.add('is-closing');
          run(body.offsetHeight, 0, function () {
            details.open = false;
            details.classList.remove('is-closing');
          });
        } else {
          var from = details.classList.contains('is-closing') ? body.offsetHeight : 0;
          details.classList.remove('is-closing');
          details.open = true;
          run(from, body.scrollHeight);
        }
      });
    });

    /* Theme editor: selecting an Offer block selects that offer. */
    section.addEventListener('shopify:block:select', function (event) {
      var card = event.target.closest && event.target.closest('[data-offer]');
      if (card) selectOffer(parseInt(card.dataset.index, 10));
    });

    render();
  }

  function initAll(scope) {
    (scope || document).querySelectorAll('[data-offer-box]').forEach(init);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { initAll(); });
  } else {
    initAll();
  }
  document.addEventListener('shopify:section:load', function (event) { initAll(event.target); });
})();
